import { render, staticRenderFns } from "./ArtistTracks.vue?vue&type=template&id=0806d418&"
import script from "./ArtistTracks.vue?vue&type=script&lang=ts&"
export * from "./ArtistTracks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports